import { Component, Input } from '@angular/core';
import { ComponentBase, DeploymentContext, UserService } from '@Common';
import {
	AssetKey,
	Company,
	LocalizedTextIds,
	PublicOverrides,
} from 'company-finder-common';

@Component({
	selector: 'public-information',
	templateUrl: './public-information.component.html',
	styleUrls: ['./public-information.component.scss'],
	standalone: false,
})
export class PublicInformationComponent extends ComponentBase {
	@Input()
	public company: Company;

	constructor(context: DeploymentContext, private userService: UserService) {
		super(context);
	}

	public get includeInPublicView(): PublicOverrides {
		return this.featureSwitches.includeInPublicView;
	}

	public get isForCompanyContact(): boolean {
		return this.userService
			.getCompanyListsSync()
			?.isCompanyContactFor?.includes(this.company.name);
	}

	public get showInvestmentSummary(): boolean {
		return (
			this.featureSwitches.includeInPublicView &&
			this.company.totalSecuredAndContingentAmount > 0
		);
	}

	public get assetTitle(): string {
		return this.Loc(LocalizedTextIds.Assets);
	}

	public get assetColumns(): AssetKey[] {
		return [
			'name',
			'focusArea',
			'therapeuticArea',
			'indication',
			'target',
			'routeOfAdministration',
			'developmentStage',
		];
	}
}
